var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhistle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 14.0001H17.512M5.54199 9.04175V14.0001H9.04199C10.9752 14.0001 12.472 15.7454 13.7262 17.2166C14.2659 17.8498 14.9564 18.337 15.7339 18.6333C16.5114 18.9297 17.3509 19.0255 18.1752 18.9122C18.9995 18.7988 19.782 18.4798 20.4507 17.9846C21.1193 17.4894 21.6526 16.8339 22.0014 16.0784C22.3501 15.323 22.5032 14.492 22.4464 13.6618C22.3897 12.8317 22.1249 12.0292 21.6766 11.3283C21.2282 10.6274 20.6107 10.0505 19.8809 9.65096C19.151 9.25136 18.3324 9.04186 17.5003 9.04175H16.6253V9.62508C16.6253 9.9345 16.5024 10.2312 16.2836 10.45C16.0648 10.6688 15.7681 10.7917 15.4587 10.7917H13.7087C13.3992 10.7917 13.1025 10.6688 12.8837 10.45C12.6649 10.2312 12.542 9.9345 12.542 9.62508V9.04175H5.54199Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle);
export default __webpack_public_path__ + "static/media/whistle.e467b44042af8b4e75f208510f7e0b92.svg";
export { ForwardRef as ReactComponent };